import { Button, Col, Modal, Row } from "react-bootstrap";
import { ProdutoNFCePropriedadesProps } from "src/pages/Privada/Fiscal/NFCe/Modal.Item/NFCe.Modal.Item.Propriedades.View";

export const NFeCadastroItemModalPropriedadesView = (
  props: ProdutoNFCePropriedadesProps
) => {
  const onDeleteHandler = () => {
    if (props.produto) {
      props.onCancel();
      props.onDelete(props.produto);
    }
  };

  return (
    <>
      <Modal show={props.show} centered>
        <Modal.Body>
          <Row>
            <Col>
              {props.produto?.nome}[{props.produto?.codigoProduto}]
            </Col>
          </Row>
          <Row>
            <Col xs={6}>Quantidade: {props.produto?.quantidadeComercial}</Col>
            <Col xs={6}>
              Valor Unitário:{" "}
              {props.produto?.valorUnitarioComercial
                ? props.produto.valorUnitarioComercial
                    .toFixed(2)
                    .replace(".", ",")
                : "0,00"}
            </Col>
          </Row>
          <Row>
            <Col xs={6}>
              Valor Total:{" "}
              {props.produto?.valorUnitarioComercial &&
              props.produto.quantidadeComercial
                ? (
                    props.produto.valorUnitarioComercial *
                    props.produto.quantidadeComercial
                  )
                    .toFixed(2)
                    .replace(".", ",")
                : "0,00"}
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onCancel}>Voltar</Button>
          <Button
            variant="outline-danger"
            className="messagebox-btn-cancel"
            onClick={onDeleteHandler}
          >
            Excluir
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
